import { FlexMixin } from '@ui-kit/styles/common/mixins/helpers.styled';
import styled from 'styled-components';

export const Wrapper = styled.div`
	${FlexMixin({})}
`;
